import { render, staticRenderFns } from "./CDivider.vue?vue&type=template&id=281e5762&scoped=true&"
import script from "./CDivider.vue?vue&type=script&lang=ts&"
export * from "./CDivider.vue?vue&type=script&lang=ts&"
import style0 from "./CDivider.vue?vue&type=style&index=0&id=281e5762&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e5762",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
